import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import RadiusInput from 'components/common/formElements/radiusInput';
import { IAuthData, IError } from 'types';
import Form from 'components/common/formElements/form';
import Logo from 'components/common/logo';
import { loginErrorMessageSelector } from 'selectors/auth';
import Robot from 'style/imgs/Backpack.svg';

// import { getUnits } from 'actions/scholars';
import { userLogin, clearAuthErrors } from 'actions/auth';

import google from 'style/imgs/socialIcons/google.png';
import faceBook from 'style/imgs/socialIcons/faceBook.svg';

import { logEvent } from 'services/amplitude';
import buttons from 'style/buttons.module.scss';
import ForgotPassword from 'components/common/restorPassword/forgotPassword';
import Modal from 'components/common/modal/modal';
import MobileService from 'services/mobile';
import styles from '../signUp/index.module.scss';

const Login: React.FC = () => {
  const [open, setOpen] = useState(false);

  const errorMessage = (useSelector(
    loginErrorMessageSelector
  ) as unknown) as IError;

  const dispatch = useDispatch();

  const schema = yup.object().shape({
    email: yup.string().email().required(),
    password: yup.string().required(),
  });

  const { register, handleSubmit, errors } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const modalOpen = () => {
    setOpen(!open);
  };

  const onSubmit = async (values: IAuthData) => {
    const requestData = {
      email: values.email,
      password: values.password,
      userType: localStorage.getItem('role') || '',
    };
    if (!open) {
      await dispatch(userLogin(requestData));
      // dispatch(getUnits());
      logEvent('Login');
    }
  };

  useEffect(() => {
    dispatch(clearAuthErrors('login'));
  }, [dispatch]);

  return (
    <div
      className={`${styles.signUp} ${
        MobileService.isMobile ? styles.tablet : ''
      }`}
    >
      <div className={styles.signUpLeft}>
        <div className={styles.robot}>
          <img src={Robot} alt="img" />
        </div>
      </div>
      <div className={styles.signUpRight}>
        <div className={styles.logo}>
          <Logo />
        </div>
        <h1 className="deep-gray-heading">Login</h1>
        <div className={styles.trapezoid}>
          {!MobileService.isMobile && (
            <div className={styles.singUpWith}>
              <div>
                <div>
                  <img src={faceBook} alt="Facebook" />
                </div>
                <span>Sign in with Facebook</span>
              </div>
              {/* <div>
              <div>
                <img src={apple} alt="Apple" />
              </div>
              <span>Sign in with Apple ID</span>
            </div> */}
              <div>
                <div>
                  <img src={google} alt="Google" />
                </div>
                <span>Sign in with Google</span>
              </div>
            </div>
          )}
          <div className={styles.line}>
            <div />
            <span>Or</span>
          </div>
          <Form id="form-1" onSubmit={handleSubmit(onSubmit)}>
            <RadiusInput
              variant="outlined"
              type="text"
              label="Your email"
              name="email"
              ref={register}
              error={!!errors.email}
            />
            <RadiusInput
              variant="outlined"
              type="password"
              label="Your password"
              name="password"
              ref={register}
              error={!!errors.password}
            />
            {!!errorMessage && (
              <span className="error-message">{errorMessage}</span>
            )}
            <div className={styles.link}>
              <Modal
                modalOpen={modalOpen}
                isOpen={open}
                modalContent={<ForgotPassword modalOpen={modalOpen} />}
                trigger={<div className="orange-heading">Forgot password?</div>}
              />
            </div>
            <button type="submit" className={buttons.buttomPrimary}>
              Login
            </button>
          </Form>
        </div>
        <div className={`gray-text ${styles.signUpLink}`}>
          Not a member?{' '}
          <Link className="orange-heading" to="/choose-role">
            Sign up now
          </Link>
        </div>
        <a
          href="https://anetaed.zendesk.com/hc/en-us"
          target="_blank"
          rel="noreferrer"
          className="question"
        >
          ?
        </a>
      </div>
    </div>
  );
};

export default Login;
